import {
  API_EMBED_MATERIAL,
  OPEN_API_CREATE_COMPLETION,
  API_LLM_COMPLETIONS_CHAT_ENGINE,
  SUPABASE_VECTOR_SEARCH
} from '../constants/api';
import * as twApi from './tw-api';
/**
 * @summary creates pdf from template & JSON
 * @param {object} prompt // json
 *
 */
export const createCompletion = ({
  prompt
}) => {
  return new Promise((resolve, reject) => {
    const data = {
      prompt
    };

    return twApi.post(OPEN_API_CREATE_COMPLETION, '', JSON.stringify(data)).then((response) => {
      resolve(response);
    }).catch((error) => {
      console.error(error);
      reject(error);
    });
  });
};

/**
 * @summary search similar embeddings with prompt
 */
export const vectorSearch = ({
  refIds = null,
  orgId = '',
  locationId = '',
  integrationId = null,
  userId = '',
  parentIds = null,
  contentTypes = null,
  parentType = 'resourceGroup', // TODO change to resourceGroups
  saveSearch = false,
  prompt = '',
  searchText = '',
  threshold = 0.78,
  count = 5
}) => {
  return new Promise((resolve, reject) => {
    const data = {
      orgId,
      locationId,
      userId,
      contentTypes,
      saveSearch,
      threshold,
      count,
      parentType
    };

    if (prompt) {
      data.prompt = prompt;
    }

    if (integrationId) {
      data.integrationId = integrationId;
    }

    if (searchText) {
      data.searchText = searchText;
    }

    if (refIds) {
      data.refIds = refIds;
    }

    if (parentIds) {
      data.parentIds = parentIds;
    }

    return twApi.get(SUPABASE_VECTOR_SEARCH, data).then((response) => {
      resolve(response?.data);
    }).catch((error) => {
      console.error(error);
      reject(error);
    });
  });
};

/**
 * @summary search similar embeddings with summary or Q&A
 */
export const chatEngine = async ({
  orgId = '',
  systemPrompt = '',
  prompt = '',
  promptType = '',
  refId = '',
  resourceVecIds = undefined,
  searchId
}) => {
  const streaming = true;
  const body = {
    ...(systemPrompt ? { systemPrompt } : {}),
    ...(prompt ? { prompt } : {}),
    ...(promptType ? { promptType } : {}),
    ...(refId ? { refId } : {}),
    ...(resourceVecIds ? { resourceVecIds } : {}),
    ...(searchId ? { searchId } : {}),
    orgId
  };

  try {
    const response = await twApi.post(API_LLM_COMPLETIONS_CHAT_ENGINE, '', JSON.stringify(body), streaming);
    return response;
  } catch (error) {
    console.error(error);
    throw new Error(error);
  }
};

export const embedMaterial = ({
  orgId = '',
  materialId = '',
  resourceId = ''
}) => {
  return new Promise((resolve, reject) => {
    const data = {
      materialId,
      resourceId,
      orgId
    };

    return twApi.post(API_EMBED_MATERIAL, '', JSON.stringify(data)).then((response) => {
      resolve(response);
    }).catch((error) => {
      console.error(error);
      reject(error);
    });
  });
};
